export default __webpack_public_path__ + "static/media/beyonce-album.491061b7.png";